module.exports = __webpack_public_path__ + "static/media/loginBackground.023966d4.jpg";